import { FaStar } from "react-icons/fa6";
import { IoArrowForwardOutline } from "react-icons/io5";

import { Img } from "shared/ui/img";

type Props = {
  title: string;
  icon: string;
  avgTime: string;
  rate: string;
  onClick: () => void;
};

export const ProviderCard = (props: Props) => {
  const { title, icon, avgTime, rate, onClick } = props;
  return (
    <div
      onClick={onClick}
      className="bg-whiteSmoke relative flex w-full cursor-pointer gap-x-4 rounded-lg p-5"
    >
      <button className="absolute top-3 right-3 flex size-8 items-center justify-center">
        <IoArrowForwardOutline className="size-6 -rotate-45" />
      </button>
      <div className="flex size-8 shrink-0">
        <Img src={icon} />
      </div>

      <div className="flex flex-col">
        <h3 className="text-balticSea text-xl leading-[140%] font-semibold">
          {title}
        </h3>
        <p className="text-balticSea/40 mt-2 text-sm">Average issuance time</p>
        <span className="text-sm leading-[140%] font-medium">{avgTime}</span>
      </div>

      <div className="text-persianOrange absolute right-3 bottom-3 flex items-center gap-x-1.5">
        <FaStar />
        <span>{rate}</span>
      </div>
    </div>
  );
};
